import * as Yup from 'yup';

const phoneRules = 'předvolba ( znak "+" a 1-3 číslice ), 8-12 číslic ';

export const dataBoxValidationSchema = Yup.string()
  .nullable()
  .matches(
    /^[abcdefghijkmnpqrstuvwxyz23456789]{7}$/,
    'Musí obsahovat 7 znaků z písmen malé anglické abecedy (bez znaků "o", "l") a číslic 2-9'
  );

export const phoneNumberValidationSchema = Yup.string()
  .nullable()
  .matches(/^(\+\d{1,3})\d{8,12}/, `Číslo nesplňuje pravidla: ${phoneRules}`);

export const faxNumberValidationSchema = phoneNumberValidationSchema;
